import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudDialogModule,
	FreudDividerModule,
	FreudInputNumberModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AddressPriceModalComponent } from './address-price-modal.component';

@NgModule({
	declarations: [AddressPriceModalComponent],
	imports: [
		CommonModule,
		FreudCardModule,
		FreudButtonModule,
		FreudInputNumberModule,
		ReactiveFormsModule,
		TranslateModule,
		FreudDialogModule,
		FreudTypographyModule,
		FreudDividerModule,
	],
	exports: [AddressPriceModalComponent],
})
export class AddressPriceModalModule {}
